import { CHCTagList } from "./tag-list.component.js";
customElements.define("chc-tag-list", CHCTagList);
export {
  CHCTagList
};
//# sourceMappingURL=tag-list.js.map
